export default __webpack_public_path__ + "static/LocusNotebook-4e414c7202a07d4ab0003f7ce33fed52.mp4";